import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Menu } from '@storable/canaveral-components';
import gql from 'graphql-tag';
import { MANAGE } from '../../../modules/authorization/actions';
import { BUILDER, FACILITY_PAGES, NON_FACILITY_PAGES } from '../../../modules/authorization/subjects';
import useCurrentUser from '../../hooks/useCurrentUser';
import PageTitle from '../PageTitle';
import styles from './styles.scss';

const propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
    facility: PropTypes.object,
    status: PropTypes.shape({
      id: PropTypes.string.isRequired,
      context: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

const defaultProps = {};

const BuilderPagesMenuItem = ({
  page,
}) => {
  const currentUser = useCurrentUser();
  const [unauthorized, setUnauthorized] = useState(true);
  const { cannot, associatedWithFacility } = currentUser;

  const {
    id,
    facility,
    status: {
      context,
      icon,
    } = {},
  } = page;

  useEffect(() => setUnauthorized(
    facility
      ? cannot(MANAGE, BUILDER, FACILITY_PAGES) || !associatedWithFacility(facility.id)
      : cannot(MANAGE, BUILDER, NON_FACILITY_PAGES),
  ), [currentUser.id]);

  return (
    <Menu.Item
      className={styles.item}
      componentClass={Link}
      context={context}
      icon={icon}
      to={`/admin/page/edit/${id}`}
      unauthorized={unauthorized}
    >
      <PageTitle
        page={page}
        useInternalName
      />
    </Menu.Item>
  );
};

BuilderPagesMenuItem.propTypes = propTypes;
BuilderPagesMenuItem.defaultProps = defaultProps;

BuilderPagesMenuItem.fragments = {
  page: gql`
    fragment BuilderPagesMenuItemPage on Page {
      id
      status {
        id
        context
        icon
      }
      ...PageTitlePage
    }

    ${PageTitle.fragments.page}
  `,
};

export default BuilderPagesMenuItem;
